'use client'

import Intercom, { onHide } from '@intercom/messenger-js-sdk'
import { ReactNode, useEffect } from 'react'

import { useAppDispatch } from '../hooks/use-app-dispatch'
import { useAppSelector } from '../hooks/use-app-selector'
import { toggleIntercom } from '../store/slice/ui-slice'

type TIntercomProvider = {
  readonly children: ReactNode
}

export default function IntercomProvider({ children }: TIntercomProvider) {
  const { userId, fullname, email } = useAppSelector((state) => state.user)

  const dispatch = useAppDispatch()

  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_INTERCOM_APP_ID

    if (!appId) {
      return
    }

    Intercom({
      app_id: appId,
      hide_default_launcher: true,
      ...(userId && { user_id: userId }),
      ...(fullname && { name: fullname }),
      ...(email && { email }),
    })

    onHide(() => dispatch(toggleIntercom(false)))
  }, [dispatch, email, fullname, userId])

  return children
}
